/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const personalRouter = {
	path: '/personal',
	component: Layout,
	redirect: 'noRedirect',
	name: '用户',
	id: 700000,
	meta: {
		title: '用户',
		icon: 'person',
		roles: [700000]
	},
	children: [{
		path: 'organization',
		component: () =>
			import(/* webpackChunkName: "organization" */ '@/leniuview/personal/organization'),
		name: '组织架构',
		id: 701000,
		meta: {
			title: 'personal.organization',
			roles: [701000]
		}
	},
	{
		path: 'location',
		component: () =>
			import(/* webpackChunkName: "location" */ '@/leniuview/personal/location'),
		name: '位置信息',
		id: 702000,
		meta: {
			title: 'personal.positioninfo',
			roles: [702000]
		}
	},
	{
		path: 'locationImport',
		component: () => import(/* webpackChunkName: "locationImport" */ '@/leniuview/personal/locationImport'),
		name: 'locationImport',
		hidden: true,
		meta: { title: '位置信息导入', noCache: true, roles: [702000] }
	},
	// {
	//   path: "bedInfo",
	//   component: () =>
	//     import ( /* webpackChunkName: "bedInfo" */ "@/leniuview/personal/bedInfo"),
	//   name: "床位信息",
	//   id: 708000,
	//   meta: { title: "床位信息", roles: [702000] }
	// },
	{
		path: 'personnal',
		component: () =>
			import(/* webpackChunkName: "personnal" */ '@/leniuview/personal/personal'),
		name: '人员资料',
		id: 704000,
		meta: {
			title: 'personal.renyuaninfo',
			noCache: true,
			roles: [704000]
		}
	},
	{
		path: 'daorujieguo',
		component: () =>
			import(/* webpackChunkName: "daorujieguo" */ '@/leniuview/personal/daorujieguo'),
		name: '导入人员结果查询',
		meta: {
			title: '导入人员结果查询',
			noCache: true,
			roles: [704000]
		},
		hidden: true
	},
	// {
	//   path: "personnalCasual",
	//   component: () =>
	//     import ( /* webpackChunkName: "personnalCasual" */ "@/leniuview/personal/linshi"),
	//   name: "临时人员",
	//   id: 706000,
	//   meta: {
	//     title: "personal.linshi",
	//     roles: [706000]
	//   }
	// },
	{
		path: 'personnalLogOut',
		component: () =>
			import(/* webpackChunkName: "personnalLogOut" */ '@/leniuview/personal/cust-cancel'),
		name: '人员注销',
		id: 711000,
		meta: {
			title: 'personal.logOut',
			roles: [711000]
		}
	},
	{
		path: 'cardbind',
		component: () => import('@/leniuview/personal/cardbind'),
		name: '卡片绑定',
		id: 707000,
		meta: { title: 'personal.kapianbangding', roles: [707000] }
	},
	{
		path: 'carddeductfeerecord',
		component: () => import('@/leniuview/personal/carddeductfeerecord'),
		name: '卡片扣除费用记录',
		id: 709000,
		meta: { title: 'personal.kpkouchujilu', roles: [709000] }
	},
	{
		path: 'peoplecardsum',
		component: LayoutView,
		name: '人员办卡汇总',
		id: 803000,
		meta: {
			title: 'baobiaozhongxin.peoplecardsum',
			roles: [803000]
		},
		redirect: 'peoplecardsum',
		children: [{
			path: 'peoplechangecard',
			component: () =>
				import(/* webpackChunkName: "peoplechangecard" */ '@/leniuview/reportCenter/peoplecardsum/peoplechangecard'),
			name: '人员换卡记录表',
			id: 803100,
			meta: {
				title: 'baobiaozhongxin.peoplechangecard',
				roles: [803100]
			}
		},
		{
			path: 'deptcard',
			component: () =>
				import(/* webpackChunkName: "deptcard" */ '@/leniuview/reportCenter/peoplecardsum/deptcard'),
			name: '部门发卡汇总表',
			id: 803200,
			meta: {
				title: 'baobiaozhongxin.deptcard',
				roles: [803200]
			}
		}
		]
	},
	{
		path: 'personallabel',
		component: LayoutView,
		name: '人员标签管理',
		id: 703000,
		meta: {
			title: 'personal.personallabel',
			roles: [703000]
		},
		redirect: 'position',
		children: [{
			path: 'position',
			component: () =>
				import(/* webpackChunkName: "position" */ '@/leniuview/personal/position'),
			name: '职位职称',
			id: 703100,
			meta: {
				title: 'personal.position',
				roles: [703100]
			}
		},
		{
			path: 'psnType',
			component: () =>
				import(/* webpackChunkName: "psnType" */ '@/leniuview/personal/psnType'),
			name: '人员类别',
			id: 703200,
			meta: {
				title: 'personal.psntype',
				roles: [703200]
			}
		}
		]
	}
	]
}

export default personalRouter
